import { writable } from 'svelte/store';
import type { Location } from '../../types';
import type { FormData } from './types';

export const createEnquiryStore = () => {
  const { subscribe, update } = writable({
    locations: [] as Location[],
    loading: true,
    errorMessage: null as string | null,
    validationIssues: {} as { [key: string]: string | undefined }
  });

  return {
    subscribe,
    setLocations: (locations: Location[]) => 
      update(state => ({ ...state, locations, loading: false })),
    setError: (error: string) => 
      update(state => ({ ...state, errorMessage: error })),
    setValidationIssues: (issues: { [key: string]: string | undefined }) => 
      update(state => ({ ...state, validationIssues: issues }))
  };
};

export const enquiryStore = createEnquiryStore();
export const formStore = writable<Partial<FormData>>({});
export const validationStore = writable<Record<string, string | undefined>>({});
export const errorStore = writable<string | null>(null);